'use strict';

export class commentCtrl
{
//	$scope;
//	$filter;
//	$timeout;
//	jsDataService;
//	notify;

//	showRequire = false;
//	
	constructor($scope, $filter, jsDataService, notify){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.notify = notify;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.postConstruct();
	}
	postConstruct(){
		this.comment = this.jsDataService.get('comment');
	}

	autosavePostFields(){
		return {
			comment: this.comment
		};
	}

	go2Url(urlString){
		console.log(urlString)
		this.$scope.goUrl(urlString);
	}	

}